import {
  Box,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  SelectChangeEvent,
  Typography
} from '@mui/material';
import { ReactNode } from 'react';
import { useAuth } from '@contexts/AuthContext';
import { CustomSelect } from '@ui/select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function PropertySelectorHRWO({ selectedProperties, setSelectedProperties}: { selectedProperties?: any[], setSelectedProperties?: any }) {
  const { user } = useAuth();

  const selectAllProperties = () => {
    setSelectedProperties(user?.properties.map((p: any) => p.id));
  }

  const clearSelection = () => {
    setSelectedProperties([]);
  }

  return (
    <FormControl sx={{ m: 1, width: 300 }}>
      <InputLabel sx={{mt: '-5px'}} id="demo-simple-select-label">Select Properties</InputLabel>
      <CustomSelect
        labelId="demo-simple-select-label"
        value={selectedProperties}
        onChange={(event: SelectChangeEvent) => {
          console.log(event.target.value);
          setSelectedProperties(event.target.value);
        }}
        input={<OutlinedInput label="Select Properties" />}
        multiple
        renderValue={((value: any) => {
          return <Typography
            variant="h4"
            sx={{
              fontWeight: 400,
              color: '#5A6A72',
              maxWidth: '500px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {value.length > 0 ? user?.properties.filter((p) => value.includes(p.id)).map((v: any) => v.name).join(', ') : 'Select Properties'}
          </Typography>
        })}
      >
        <Box sx={{mx: 2, mt: 1, display: 'flex', justifyContent: 'space-between'}}>
          <Typography sx={{cursor: 'pointer'}} onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            selectAllProperties();
          }}>Select All</Typography>
          <Typography sx={{cursor: 'pointer'}} onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            clearSelection();
          }}>Clear</Typography>
        </Box>
        {(user?.properties ?? []).map((p, idx) => {
          return (
            <MenuItem key={idx} value={p.id}>
              <Checkbox checked={selectedProperties?.includes(p.id)} />
              <ListItemText>{p.name}</ListItemText>
            </MenuItem>
          );
        })}
      </CustomSelect>
    </FormControl>
  );
}
